import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleChipEditableField } from '../../ui/fields/TitleChipEditableField';

export function KeywordsField({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.keywords(localizedInfoUuid), [localizedInfoUuid]);
	return <TitleChipEditableField path={path} label="Keywords" ariaLabel="Keywords" />;
}
